export default "/assets/lobby2.44923dd7222b7f63e8c496f3d49d9caf.png";